"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuOption = void 0;
class MenuOption {
    constructor(params) {
        Object.assign(this, params);
    }
    equalsCode(code) {
        return this.trimSpaces(this.code) === code;
    }
    containsCode(code) {
        return this.codes.some(val => this.trimSpaces(val) === code);
    }
    trimSpaces(str) {
        return str + ''.replace(" ", "");
    }
}
exports.MenuOption = MenuOption;
//# sourceMappingURL=menu-option.js.map